/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.app.rpc.FormMetadataRpc
 */
import * as References from './FormMetadataRpc';
import { createRpcClientV2, type RpcClientV2 } from 'rpc-client-utils';
import portalsHttpClient from 'portals-platform-lib/portalsHttpClient';
import {
  DataFetchingClientFetcherContext,
  RegisteredQuery,
} from 'data-fetching-client';
import { registerQuery } from 'data-fetching-client/next';
export type AdditionalContextArgs = {
  /**
   * Timeout for the request in milliseconds. If not provided, the default timeout of 5000 will be used.
   */
  timeout?: number;
  /**
   * Not recommended for usage. Please use build time client instead by updating `.client-types.config.ts`file.
   * Docs: https://product.hubteam.com/docs/chirp/pages/tutorials/chirp/FE/custom-clients.html.
   *
   * Used to overwrite the default Chirp Client during runtime.
   */
  customClient?: RpcClientV2;
};

const chirpClient = createRpcClientV2({
  hubHttpClient: portalsHttpClient,
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.app.rpc.FormMetadataRpc#getFormMetadata
 */
export const GET_FORM_METADATA_QUERY_FIELD_NAME =
  'com_hubspot_portals_platform_app_rpc_FormMetadataRpc_getFormMetadata';
export const GET_FORM_METADATA_QUERY: RegisteredQuery<
  'result',
  References.GetFormMetadataRequestType,
  References.GetFormMetadataResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_FORM_METADATA_QUERY_FIELD_NAME,
  args: [
    'formGuid',
    'membershipToken',
    'utkCookie',
    'portalInstanceId',
    'accountId',
    'objectId',
    'membershipCsrfTokenFromClient',
    'membershipCsrfTokenFromCookie',
    'previewJwt',
  ],
  fetcher(
    request: References.GetFormMetadataRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetFormMetadataResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getFormMetadataRpc,
      { timeout: ctx.timeout, request }
    );
  },
});
